import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/chat/templates/Conversational.tsx
// Plain text for greetings, clarifications, acknowledgements.
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { AssumptionsCallout } from "../AssumptionsCallout";
// Tailwind preflight resets <ul>/<ol> to list-style:none with no padding,
// so markdown bullets vanish unless we explicitly re-style them. Component
// overrides give precise control without relying on the @tailwindcss/typography
// `prose` class (which would also restyle headings, links, code blocks, etc.).
const MARKDOWN_COMPONENTS = {
    ul: ({ children, ...props }) => (_jsx("ul", { className: "list-disc list-outside pl-5 space-y-1 my-2", ...props, children: children })),
    ol: ({ children, ...props }) => (_jsx("ol", { className: "list-decimal list-outside pl-5 space-y-1 my-2", ...props, children: children })),
    li: ({ children, ...props }) => (_jsx("li", { className: "leading-relaxed", ...props, children: children })),
    p: ({ children, ...props }) => (_jsx("p", { className: "my-1", ...props, children: children })),
};
export function Conversational({ message }) {
    const text = message.content?.trim() ?? "";
    const assumptions = message.assumptions_used ?? [];
    return (_jsxs("div", { className: "text-sm text-slate-200 leading-relaxed", children: [_jsx(AssumptionsCallout, { assumptions: assumptions }), _jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], components: MARKDOWN_COMPONENTS, children: text })] }));
}
